"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnIntervalWidthIterator = void 0;
var ColumnIntervalWidthIterator = (function () {
    function ColumnIntervalWidthIterator(columnsInfo) {
        this.columnsInfo = columnsInfo;
        this.intervalIndex = 0;
        this.interval = columnsInfo[0];
    }
    ColumnIntervalWidthIterator.prototype.endOfIntervals = function () {
        return !this.interval;
    };
    ColumnIntervalWidthIterator.prototype.moveNext = function () {
        this.intervalIndex++;
        this.interval = this.columnsInfo[this.intervalIndex];
    };
    ColumnIntervalWidthIterator.prototype.advance = function (interval) {
        if (this.interval.colSpan == interval.colSpan)
            this.moveNext();
        else
            this.interval = this.interval.substract(interval);
    };
    return ColumnIntervalWidthIterator;
}());
exports.ColumnIntervalWidthIterator = ColumnIntervalWidthIterator;
